import Vue from "vue";
import Router from "vue-router";
import i18n from '@/i18n'; 


import Home from "./views/home/Index.vue"; //首页
import OrderList from "./views/order/List.vue"; //订单列表
import SubmitOrder from "./views/order/SubmitOrder.vue"; //提交订单
import orderDetail from "./views/order/orderDetail.vue"; //订单详情

import PaySuccess from "./views/order/PaySuccess.vue"; //支付成功

import CardPackage from "./views/card/Package.vue"; //订餐
import CardPackageForm from "./views/card/PackageForm.vue"; //订餐

import SelectBranch from "./views/card/SelectBranch.vue"; //选择分店
import SelectNewBranch from "./views/card/newBranch.vue"; //车间预定

import Me from "./views/me/Index.vue"; //我的
import Login from "./views/auth/Login.vue"; //登录
import ScanLogin from './views/auth/ScanLogin.vue'; // 扫码登录页面
import Repass from "./views/auth/Repass.vue"; //修改密码
// import Register from "./views/auth/Register.vue";
import Face from "./views/face/Index.vue";

import NewAddress from "./views/merchants/address/Address.vue"; //新增地址
import AdminAdress from "./views/merchants/address/Adminadress.vue"; //管理地址
import SelectAdress from "./views/merchants/address/SelectAdress.vue"; //选择地址
import CialAdress from "@/views/merchants/address/CialAdress"; //官方地址

import RoomClerk from "@/views/roomclerk/Index.vue";
import Range from "@/views/range/Range";

//营养数据
import Nutrition from "./views/nutrition/index.vue"; //营养
import RecordsHealth from "./views/RecordsHealth/index.vue"; // 健康档案
import dayNutrisystem from "./views/Nutrisystem/dayNutrisystem";
//评价订单
import EvalueOrder from "@/views/order/EvalueOrder"; //评价订单
import SeeEvalue from "@/views/order/SeeEvalue";
import Gateway from "@/views/gateway/index.vue";

//协议
import Protocol from "@/views/auth/Protocol.vue";

// 首页
import Page from "./views/page/Page.vue";
// 支付码
import PayqrCode from "./views/qrcode/PayqrCode.vue";

Vue.use(Router);

const router = new Router({
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      component: Home,
      meta: {},
    },
    {
      path: "/gateway",
      component: Gateway,
      meta: {},
    },
    {
      path: "/login",
      component: Login,
      meta: {
        title: "loginBtn",
      },
    },
    {
      path: '/scan/login',
      component: ScanLogin,
      meta: {
        title: 'loginBtn'
      }
    },
    // {
    //   path: "/register",
    //   component: Register,
    //   meta: {
    //     title: "注册",
    //   },
    // },
    {
      path: "/repass",
      component: Repass,
      meta: {
        title: "updatePasswordTitle",
      },
    },
    {
      path: "/card/package",
      component: CardPackage,
      name: 'cardPackage',
      meta: {
        title: "cardPackageTitle",
        keepAlive: true,
        tabbar: true,
      },
    },
    {
        path: "/card/packageForm",
        component: CardPackageForm,
        name: 'packageForm',
        meta: {
          title: "cardPackageTitle",
          keepAlive: true,
          tabbar: true,
        },
    },
    {
      path: "/card/selectBranch",
      component: SelectBranch,
      meta: {
        title: "branchTitle",
        keepAlive: true,
      },
    },
    {
        path: "/card/selectNewBranch",
        component: SelectNewBranch,
        name: 'SelectNewBranch',
        meta: {
          title: "workshopTitle",
          keepAlive: true,
        },
      },
    {
      path: "/order/list",
      component: OrderList,
      meta: {
        // keepAlive: true,
        title: "orderTitle",
        tabbar: true,
      },
    },
    {
      path: "/order/submit",
      component: SubmitOrder,
      meta: {
        keepAlive: true,
        title: "submitOrderTitle",
      },
    },
    {
      path: "/me/index",
      component: Me,
      meta: {
        title: "mineTitle",
        tabbar: true,
        // keepAlive: true,
      },
    },
    {
      path: "/merchants/address/Address",
      component: NewAddress,
      meta: {
        title: "addAddressTitle",
      },
    },
    {
      path: "/order/detail",
      component: orderDetail,
      meta: {
        title: "orderDetailTitle",
        // keepAlive: true,
      },
    },
    {
      path: "/order/paysuccess",
      component: PaySuccess,
      meta: {
        title: "paySuccess",
        keepAlive: true,
      },
    },
    {
      path: "/merchants/adminAdress",
      component: AdminAdress,
      meta: {
        title: "地址管理",
      },
    },
    {
      path: "/merchants/selectAdress",
      component: SelectAdress,
      meta: {
        title: "selectAddressTitle",
      },
    },
    {
      path: "/face/index",
      component: Face,
      meta: {
        title: "人脸列表",
      },
    },
    {
      path: "/cial/adress",
      component: CialAdress,
      name: 'address',
      meta: {
        title: "selectAddressTitle",
      },
    },
    {
      path: "/room/clerk",
      component: RoomClerk,
      meta: {
        title: "送餐员系统",
      },
    },
    {
      path: "/range",
      component: Range,
      meta: {
        title: "rangeTitle",
      },
    },
    {
      path: "/nutitron/home",
      component: Nutrition,
      meta: {
        title: "营养数据",
        tabbar: true,
      },
    },
    {
      path: "/recordsHealth",
      component: RecordsHealth,
      meta: {
        title: "健康档案",
      },
    },
    {
      path: "/dayNutrisystem",
      component: dayNutrisystem,
      meta: {
        title: "营养分析",
      },
    },
    {
      path: "/order/evalueOrder",
      component: EvalueOrder,
      meta: {
        title: "评价订单",
      },
    },
    {
      path: "/order/seeEvalue",
      component: SeeEvalue,
      meta: {
        title: "查看评价",
      },
    },
    {
      path: "/auth/protocol",
      component: Protocol,
      meta: {
        title: "用户协议及隐私政策",
      },
    },
    {
      path: "/page",
      component: Page,
      meta: {
        title: "homeTitle",
      },
    },
    // outHospital
    {
      path: "/outHospital",
      component: () =>
        import(
          /* webpackChunkName: "outHospital" */
          "./views/page/outHospital.vue"
        ),
      meta: {
        title: "出院",
      },
    },
    {
      path: "/pay/qrcode",
      component: PayqrCode,
      meta: {
        title: "支付码",
      },
    },
    {
      path: "/location/reserve",
      redirect: "/location/reserve/index",
      component: () =>
        import(
          /* webpackChunkName: "location" */
          "./views/location/reserve/TabbarView.vue"
        ),
      children: [
        {
          path: "/location/reserve/index",
          component: () =>
            import(
              /* webpackChunkName: "location" */
              "./views/location/reserve/Index.vue"
            ),
          meta: {
            title: "locationTabbarTitle",
          },
        },
        {
          path: "/location/reserve/order/submit",
          component: () =>
            import(
              /* webpackChunkName: "location" */
              "./views/location/reserve/OrderSubmit.vue"
            ),
          meta: {
            title: "reserveStatus3",
          },
        },
        {
          path: "/location/reserve/order/list",
          component: () =>
            import(
              /* webpackChunkName: "location" */
              "./views/location/reserve/OrderList.vue"
            ),
          meta: {
            title: "reserveListTitle",
          },
        },
        {
          path: "/location/reserve/order/detail",
          component: () =>
            import(
              /* webpackChunkName: "location" */
              "./views/location/reserve/OrderDetail.vue"
            ),
          meta: {
            title: "reserveStatus5",
          },
        },
        {
          path: "/location/reserve/order/submit/result",
          component: () =>
            import(
              /* webpackChunkName: "location" */
              "./views/location/reserve/OrderSubmitResult.vue"
            ),
          meta: {
            title: "reserveResultTitle",
          },
        },
      ],
    },
    {
      path: "/common/iframe",
      component: () =>
        import(
          /* webpackChunkName: "common" */
          "./views/common/commonIframe.vue"
        ),
      meta: {
        title: "餐券系统",
        tabbar: true,
        key: "commonIframe",
      },
    },
    // 智能评价
    {
      path: "/evaluation/index",
      component: () =>
        import(
          /* webpackChunkName: "evaluation" */ "./views/evaluation/index.vue"
        ),
      meta: {
        title: "evaluationTitle",
      },
    },
    {
      path: "/evaluation/reply",
      component: () =>
        import(
          /* webpackChunkName: "evaluation" */ "./views/evaluation/reply.vue"
        ),
      meta: {
        title: "evaluationContentTitle",
      },
    },
    {
      path: "/evaluation/explain",
      component: () =>
        import(
          /* webpackChunkName: "evaluation" */ "./views/evaluation/explain.vue"
        ),
      meta: {
        title: "evaluationExplainTitle",
      },
    },
    {
      path: "/feed/index",
      component: () =>
        import(/* webpackChunkName: "feed" */ "./views/feedback/Index.vue"),
      meta: {
        title: "feedbackTitle",
      },
    },
    {
      path: "/feed/from",
      component: () =>
        import(/* webpackChunkName: "feed" */ "./views/feedback/FeedFrom.vue"),
      meta: {
        title: "submitFeedTitle",
      },
    },
    {
      path: "/feed/detail",
      component: () =>
        import(
          /* webpackChunkName: "feed" */ "./views/feedback/FeedDetail.vue"
        ),
      name: "FeedDetail",
      meta: {
        title: "feedDetailTitle",
      },
    },
    {
      path: "/change/shop",
      component: () => import(/* webpackChunkName: "shop" */"@/views/me/ChangeShop"),
      meta: {
        title: "changeShopTitle",
      },
    },
    {
      path: '/card/detail',
      component: () => import(/* webpackChunkName: "shop" */'./views/me/ShopCardDetail.vue'),
      meta: {
        title: 'cardDetailTitle'
      }
    },
    {
      path: '/no/permission',
      component: () => import(/* webpackChunkName: "permission" */ "./views/permission/noPermission.vue"),
      meta: {
        title: 'noPromises'
      }
    },
    {
      path: '/crowd/index',
      component: () => import(/* webpackChunkName: "crowdFlow" */ "./views/crowdFlow/index.vue"),
      meta: {
        title: 'flowCrowd'
      }
    }
  ],
});

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = i18n.t(to.meta.title);
  } else {
    document.title = i18n.t('pageTitle');
  }
  if (to.query.dev) {
    // sessionStorage.setItem("token", "00000");
  }
  if (/\/merchant/.test(to.path)) {
    return next();
  }
  if (
    to.path == "/login" ||
    // to.path == "/register" ||
    to.path == "/repass" ||
    to.path == "/"
  ) {
    return next();
  }
  // const tokenStr = sessionStorage.getItem("token");
  // const tokenStr = localStorage.getItem("customerId");
  // if (!tokenStr) {
  //   return next("/login");
  // }
  next();
});

// 系统级别，业务跳转勿用
const system = {
  push: router.push.bind(router),
  replace: router.replace.bind(router),
  back: router.back.bind(router),
  go: router.go.bind(router),
};
router.$system = system;
const types = ["push", "replace", "back", "go"]; // 重写跳转相关函数

const navigation = (type) => {
  return (...args) => {
    // 其他逻辑 这里做判定如果是编辑状态就禁止跳转
    // if (isEditing()) {
    //   console.log("stop to router");
    //   return;
    // }

    return system[type](...args);
  };
};

types.forEach((type) => {
  router[type] = navigation(type);
});

export default router;
